import { isEmpty } from 'lodash';

const STOCK_STATUS_I18N_KEY = {
  'Stok Tersedia': 'filter.in_stock',
  'Stok Habis': 'filter.out_of_stock',
  'Stok Menipis': 'filter.low_stock',
};

const getStockStatusResponse = (response, t) => {
  if (isEmpty(response?.data?.status)) return [];

  return response.data.status.map((opt) => ({
    value: opt?.name,
    label: t ? t(STOCK_STATUS_I18N_KEY[opt?.name] ?? opt?.name) : opt?.name,
  }));
};

export default getStockStatusResponse;
